/* global Symbol */

// Note: this module depends on src/component/global/polyfill being loaded

// TODO: there are no data key/value pairs for the keys topupVariantId or
// bsbVariantId set anywhere in the source. Are these automatically set
// somewhere else? For now, initializing them to empty strings.
//
// Original:
//
// let TOPUP_VARIANT_ID = $('body').data('topupVariantId')
// let BSB_VARIANT_ID = $('body').data('bsbVariantId')

export const VariantKind = {
    BSB: Symbol('bsb'),
    Topup: Symbol('topup'),
};

export function get_variantid(global, kind) {
    let id = null;
    let body_data = global.document.querySelector('body').dataset;
    if (kind === VariantKind.BSB) {
        id = body_data.topupVariantId;
    } else if (kind === VariantKind.Topup) {
        id = body_data.bsbVariantId;
    }
    let hasid = Boolean(id) && typeof id === 'string';
    return hasid ? id : '';
}

export const MONTHS = {
    '1': 'January',
    '2': 'February',
    '3': 'March',
    '4': 'April',
    '5': 'May',
    '6': 'June',
    '7': 'July',
    '8': 'August',
    '9': 'September',
    '10': 'October',
    '11': 'November',
    '12': 'December',
};

export const MONTHS_FRENCH = {
    '1': 'Janvier',
    '2': 'Février',
    '3': 'Mars',
    '4': 'Avril',
    '5': 'Mai',
    '6': 'Juin',
    '7': 'Juillet',
    '8': 'Août',
    '9': 'Septembre',
    '10': 'Octobre',
    '11': 'Novembre',
    '12': 'Décembre',
};

export const MONTHS_ZH = {
    '1': '1月',
    '2': '2月',
    '3': '3月',
    '4': '4月',
    '5': '5月',
    '6': '6月',
    '7': '7月',
    '8': '8月',
    '9': '9月',
    '10': '10月',
    '11': '11月',
    '12': '12月',
};

export function get_months(global) {
    let lang = global.document.querySelector('body').dataset.lang;

    if (lang === 'fr') {
        return MONTHS_FRENCH;
    } else if (lang === 'zh') {
        return MONTHS_ZH;
    }

    return MONTHS;
}

// export const filterSelectors = {
export const FILTER_SELECTORS = {
    country: '#countrySelect',
    age: '#ageSelect',
    gender: '#genderRadios input',
    birthday: '#birthdaySelect',
    month: '#birthMonthSelect',
    birthyear: '#birthYearSelect',
    lang: '#languageSelect',
    longest_waiting: '#longestWaitingCheck',
    favorite_subject: '#favouriteSubjectSelect',
    favorite_play: '#favouriteActivitySelect',
    special_event_id: '#eventid',
    projectid: '#projectid',
};
